import PromotionListingPage from './promotion-list';

interface IShippingDiscountPromo {}

const ShippingDiscountPromo: React.FunctionComponent<IShippingDiscountPromo> = props => {
  return <PromotionListingPage promo={'SHIPPING_DISC'} promoName="Shipping Discount"/>
};

export default ShippingDiscountPromo;
